module.exports = "/fonts/ebupot-picturemark-d-60e06e9af12788f394f6ae488468eb9f.svg";